import api from '@a/config';

const path = 'v1/werkzeug/ausfuehrung';

export default {
  get: () => api.get(path),
  getById: (id) => api.get(`${path}/${id}`),
};
